const featuredCategories = [
  {
    name: 'Buty',
    nameEn: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=stylish%20white%20sneakers%20on%20a%20clean%20minimal%20surface%20with%20soft%20natural%20lighting%2C%20product%20photography%20with%20gentle%20shadows%2C%20warm%20cream%20background%2C%20european%20minimalist%20aesthetic%2C%20soft%20film%20grain%20texture%2C%20editorial%20fashion%20photography%20style%20with%20neutral%20tones%20and%20organic%20composition&width=800&height=1000&seq=featured-shoes-01&orientation=portrait',
    badge: null,
    isDark: true,
  },
  {
    name: 'Bluzy/Swetry',
    nameEn: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=cozy%20oversized%20beige%20hoodie%20folded%20neatly%20on%20a%20light%20wooden%20surface%2C%20soft%20morning%20light%20from%20window%2C%20minimalist%20product%20photography%2C%20warm%20neutral%20colors%2C%20clean%20aesthetic%2C%20gentle%20shadows%2C%20scandinavian%20style%20catalog%20photography%20with%20organic%20texture&width=800&height=1000&seq=featured-hoodies-01&orientation=portrait',
    badge: 'TOP',
    isDark: false,
  },
  {
    name: 'Koszulki',
    nameEn: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=high%20quality%20white%20cotton%20t%20shirt%20on%20a%20minimal%20hanger%20against%20a%20soft%20pastel%20background%2C%20clean%20editorial%20product%20photography%2C%20gentle%20natural%20lighting%2C%20warm%20neutral%20aesthetic%2C%20minimalist%20scandinavian%20style%2C%20soft%20shadows%20and%20organic%20composition&width=800&height=1000&seq=featured-tshirts-01&orientation=portrait',
    badge: 'NOWOŚĆ',
    isDark: false,
  },
];

export default function FeaturedCategories() {
  return (
    <section className="py-24 md:py-32 bg-background-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6 mb-16">
          <h2 className="font-heading text-4xl md:text-5xl text-foreground-900 leading-[1.15] font-bold max-w-[360px]">
            Odkryj Nasze Kategorie
          </h2>
          <p className="text-[16px] text-foreground-500 max-w-[320px] leading-relaxed font-body">
            14 kategorii produktowych z codziennymi aktualizacjami. Znajdź najlepsze okazje w jednym miejscu.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {featuredCategories.map((cat) => (
            <a
              key={cat.nameEn}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group relative rounded-2xl overflow-hidden transition-all duration-500 hover:scale-[1.02] cursor-pointer ${
                cat.isDark ? 'bg-foreground-900' : 'bg-white border border-foreground-200/30'
              }`}
            >
              {cat.badge && (
                <div className={`absolute top-5 left-5 z-10 px-3.5 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-wider ${
                  cat.badge === 'TOP'
                    ? 'bg-primary-500 text-white'
                    : 'bg-accent-500 text-white'
                }`}>
                  {cat.badge === 'TOP' && <i className="ri-flashlight-line mr-1"></i>}
                  {cat.badge}
                </div>
              )}

              <div className="relative h-[360px] overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} Kakobuy Spreadsheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                {cat.isDark && (
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/60 via-transparent to-transparent"></div>
                )}
              </div>

              <div className={`p-6 ${cat.isDark ? 'bg-foreground-900' : 'bg-white'}`}>
                <h3 className={`text-2xl font-bold mb-3 font-heading ${cat.isDark ? 'text-white' : 'text-foreground-900'}`}>
                  {cat.name}
                </h3>
                <span className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-[14px] font-semibold transition-all duration-300 ${
                  cat.isDark
                    ? 'bg-white/10 text-white hover:bg-white/20'
                    : 'bg-foreground-900 text-white hover:bg-foreground-800'
                } whitespace-nowrap`}>
                  Przeglądaj {cat.name}
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}